<template>
<b-container class="register-organization-container" v-if="form != null && loaded">
        <div class="login-form-wrapper">
    <branding-heading></branding-heading>
<div v-show="submitted">
    <h1>Please Check Your Email</h1>
    <p>If you have a lane closures account, we have sent a reset password email registered to it. Please click the link within the email.</p>

    <p><b-button @click="onSubmit">Re-send Email <b-spinner small label="Sending..." class="ml-2" v-if="saving"></b-spinner></b-button>
    <b-button class="ml-2" @click="goBack">Back to Login</b-button> </p>

</div>
<b-form @submit="onSubmit" @reset="onReset" v-show="!submitted">
    <h1>Forgot My Password</h1>
    <b-row>
        <b-col>
            <b-form-group label="Username or Email"
                :state="form.username.status"
                :invalid-feedback="form.username.invalidMessage"
            >
            <b-form-input placeholder="" v-model="form.username.value"
                :state="form.username.status"
                @input="form.username.resetStatus()"
            ></b-form-input>
            </b-form-group>
        </b-col>
    </b-row>

<b-row>
    <b-col>
        <b-alert variant="danger" v-if="isCoWUser" show><strong>City of Winnipeg users must contact tech support to reset their password.</strong></b-alert>

        <b-button variant="primary" type="button" @click="onSubmit">Reset Password <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button>

        <b-button variant="light" class="ml-3" type="button" @click="goBack">Back to Login</b-button>

    </b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
    <template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
    <ul>
        <li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
    </ul>
    <template slot="footer">
        <b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
    </template>
</b-modal>

</b-form>
</div>
</b-container>
</template>


<script>
import ForgotPasswordModel from '../models/ForgotPasswordModel';
// import Autocomplete from '@trevoreyre/autocomplete-vue'
import BootstrapField from '../utility/BootstrapField';
import ErrorHandler from '../utility/ErrorHandler';
// import treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import BrandingHeading from '../components/BrandingHeading';
import Format from '../utility/Format';
import Vue from 'vue'
// import { mapGetters } from 'vuex';
// import { mapActions } from 'vuex';
// import { mapMutations } from 'vuex';

export default {
  name: 'ForgotPassword',
  docTitle: "Forgot Password - Lane Closures",

  components: {
        BrandingHeading
  },
  data() {
    return {
        ForgotPasswordModel,
        form: null,
        saving:false,
        organizations: [],
        lineIndexError:null,
        isButtonDisabled: false,
        isCoWUser: false,
        saveState:null,
        modalRequiredFieldList: [],
        showRequiredFieldModal: false,
        show: true,
        submitted: false,
        resendToken:null,
        onSubmitPromiseDeferred: {
            resolve:null,
            reject:null
        },
        usernamePrefix:new BootstrapField({
                    value: null}),
    }
    },
    mounted() {
        this.LoadData();
        this.$nextTick(() => {
        })
   },
  methods: {
    // required fields notifying modal
    modalRequiredFieldClose(){
        this.showRequiredFieldModal = false;
    },
    showErrors(errors){
        this.submissionStatus = 'submission-error';
        this.modalRequiredFieldList = [];
        for(let field in errors) {
            this.modalRequiredFieldList.push(errors[field]);
        }
        this.showRequiredFieldModal = true;
    },

        goBack() {
            this.$router.push('/login')
        },
        onSubmit(evt) {
            evt.preventDefault()
            if (!this.validateFields()) {
                return false;
            }
            if (this.form.username.value.indexOf("@") == this.form.username.value.length - 1) {
                this.isCoWUser = true;
            } else {
                this.isCoWUser = false;
            }

            if (!this.isCoWUser) {
                let that = this;
                return new Promise(function(resolve,reject){
                    that.onSubmitPromiseDeferred.resolve = resolve;
                    that.onSubmitPromiseDeferred.reject = reject;
                    that.SaveNew(that.form);
                });
            }

        },
        onReset(evt) {
            evt.preventDefault()
            this.show = false
            this.$nextTick(() => {
            this.show = true
            })
        },


        resendEmail() {
            this.saving = true;
            if (this.resendToken != null) {
                Vue.prototype.$http({
                    method: 'get',
                    url: `${this.$store.state.apiUrl}/user/forgot-password/?jwt=${this.resendToken}&r=${Math.round(Math.random() * Math.pow(10, 6))}`
                }).then(response => {
                    // Handle Success
                }).catch(error => {
                    this.saveState = 'fail';
                    if (!ErrorHandler.HasLoginErrorCode(error)) {
                        this.showErrors(error.response.data.fields);
                    }
                    this.onSubmitPromiseDeferred.reject();
                }).finally(() => {
                    this.isButtonDisabled = false;
                    this.saving = false;
                });
            }
        },


        SaveNew(t) {
            this.saving = true;
            if (t instanceof ForgotPasswordModel) {
                let go = true;
                if (go) {
                Vue.prototype.$http({
                    method: 'post',
                    url: `${this.$store.state.apiUrl}/user/forgot-password/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
                    data: t.getRawValue()
                }).then(response => {
                    // Handle Success
                    this.saveState = 'success';
                    this.submitted = true;
                    this.submissionStatus = 'submission-success';
                    this.SaveNewSuccess();
                    this.onSubmitPromiseDeferred.resolve();
                }).catch(error => {
                    this.saveState = 'fail';
                    if (error) {
                       if (error.response) {
                            if (!ErrorHandler.HasLoginErrorCode(error)) {
                                this.showErrors(error.response.data.fields);
                            }
                       }
                   }
                    this.onSubmitPromiseDeferred.reject();
                }).finally(() => {
                    this.isButtonDisabled = false;
                    this.saving = false;
                });
                }
            }
        },
        SaveNewSuccess() {
            // this.form.SetErrors({});
        },

        validateFields() {

            let valid = this.form.validate();
            if (valid ) {
                return true;
            }
            return false;
        },


            LoadData(id = this.id) {
                this.form = new ForgotPasswordModel();
                this.loaded = true;
            },

            GetData(id) {
                if (Format.TryParseInt(id)) {
                    this.loaded = false;
                    Vue.prototype.$http.get(this.$store.state.apiUrl + "/organization/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6)))
                    .then(response => {
                        this.form = new ForgotPasswordModel(response.data);
                        // this.$store.commit('formId', response.data.Id);
                        this.loaded = true;
                    }).catch(error => {
                        if (!ErrorHandler.HasLoginErrorCode(error)) {
                            if (error.response && error.response.data) {
                                this.loaded = false;
                                this.transactionStatus = 'load-error';
                                this.errorDetails = error.response.data;
                            }
                        } else {
                            ErrorHandler.RedirectToLogin();
                        }
                    });
                }

            },


    },
}
</script>
<i18n>
{
    "en-CA": {

    }
}

</i18n>